export const providerVerifiedLabel = {
  verified: "Verified",
  unverified: "Unverified",
  outdated: "Outdated",
};
